import { cx } from "@linaria/core";
export const noLayout: string = "nc2e9vn";
export const grid: string = "g1et32pl";
export const extendedWidth: string = cx(noLayout, "en6sn9p");
export const fullWidth: string = cx(noLayout, "f3c539b");

require("./layout.linaria.module.css!=!../../../node_modules/.pnpm/@wyw-in-js+webpack-loader@0.6.0_webpack@5.99.5/node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./layout.ts");